import IEvent from "@shared/entities/RegisterEvent/IEvent";
import { IBackendConfig, useHttpService } from "@shared/services";
import axios from "axios";
import { useCallback } from "react";

export function useConfigApi() {
  const http = useHttpService();

  /** 公開 config 資料，包含 events */
  const GetPublicConfig = useCallback(async () => {
    return (
      await axios.get<{
        success: boolean;
        config: IBackendConfig;
        events: Array<IEvent>;
        time: number
      }>("/config")
    )?.data;
  }, []);

  /** 取得所有設定資料 */
  const GetAllConfig = useCallback(async () => {
    return (
      await http.get<{ success: boolean; config: IBackendConfig; events: Array<any> }>(
        "/config/management/configs"
      )
    )?.data;
  }, [http]);

  /** 更新設定資料 */
  const UpdateConfig = useCallback(
    async (systemKey: string, config: {}, remarks?: string) => {
      return (
        await http.put<{ success: boolean }>(
          `/config/management/config/${systemKey}`, {config, remarks}
        )
      )?.data;
    },
    [http]
  );

  /**
 * 取得所有 Schema 資料
 */
  const GetSchemas = useCallback(async () => {
    return (
      await http.get<{
        success: boolean;
        schemas: {};
      }>("/config/management/schemas")
    )?.data;
  }, [http]);

  /**
 * 更新活動設定
 */
  const UpdateEventConfig = useCallback(
    async (
      eventID: number,
      systemKey: string,
      eventConfig: Object,
      remarks: string
    ) => {
      return (
        await http.put<{
          success: boolean;
          configs: {};
        }>(`/config/management/event/${eventID}/config/${systemKey}`, {
          eventConfig,
          remarks,
        })
      )?.data;
    },
    [http]
  );


  /** 這裡導出可以用的API函數！ */
  return { GetPublicConfig, GetAllConfig, UpdateConfig, GetSchemas, UpdateEventConfig };
}
